import React from 'react';

const Resources = () => {
    return (
        <>
           <section id="Resources" className="ds-section">
            
            <div className="ds-section-header">
                        
            <h2 className="ds-title">Resources</h2>       
                        
            <div className="ds-description">
            <ul><br/>
            <li><a href="https://www.astrolog.org/astrolog/astfile.htm" target="_blank">Astrolog</a>
              <br/>
              <small>Open source Astrology program for chart calculations</small>
              </li><br/>
            <li><a href="https://www.astro.com/astro-databank/Main_Page" target="_blank">Astro-Databank</a>
              <br/>
              <small>Database queried for celebrity birth data</small>
              </li><br/>
            <li><a href="https://www.geonames.org/" target="_blank">GeoNames</a>
              <br/>
              <small>Geographical database for location API</small>
              </li><br/>
            <li><a href="https://mailtrap.io/" target="_blank">MailTrap</a>
              <br/>
              <small>Email delivery platform for forwarding feedback form to my inbox</small>
              </li><br/>
            <li><a href="https://webflow.com/" target="_blank">WebFlow</a>
              <br/>
              <small>Web design platform used to draft static html</small>
              </li><br/>
            <li><a href="https://www.amazon.com/Only-Astrology-Book-Youll-Ever/dp/1589796535/ref=sr_1_2?crid=HVBIOZVF27JV&keywords=astrology+books&qid=1692682532&sprefix=astrology+%2Caps%2C1089&sr=8-2" target="_blank">The Only Astrology Book You'll Ever Need </a>by Joanna Martine Woolfolk
              <br/>
              <small>Resource for matches on planet/sign combinations</small>
              </li><br/>
            </ul>
            </div>
                        
            </div>
                      
            </section> 
        </>
    );
};

export default Resources;
